import { render, staticRenderFns } from "./Grafik.vue?vue&type=template&id=70f987dc&scoped=true"
import script from "./Grafik.vue?vue&type=script&lang=js"
export * from "./Grafik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f987dc",
  null
  
)

export default component.exports